/**
 * @generated SignedSource<<aef0d2feeea5754d14db511ee8953375>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FTEInput_account$data = {
  readonly default_full_time_minutes: number;
  readonly " $fragmentType": "FTEInput_account";
};
export type FTEInput_account$key = {
  readonly " $data"?: FTEInput_account$data;
  readonly " $fragmentSpreads": FragmentRefs<"FTEInput_account">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FTEInput_account",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "default_full_time_minutes",
      "storageKey": null
    }
  ],
  "type": "accounts",
  "abstractKey": null
};

(node as any).hash = "ca39471df92061864c98dee35418444a";

export default node;
